import { useTranslation } from "react-i18next";
import { getImage } from "../../services/ImageService";

export function CustomerSection() {
    const { t } = useTranslation();
    return (
        <div
            id="customers"
            className="flex items-center w-full justify-center flex-wrap md:flex-nowrap gap-8 xl:gap-24 py-24 md:py-36 px-12 lg:px-48 xl:px-100"
        >
            <img
                src={getImage("logos/storaenso.png")}
                className="select-none w-1/4 lg:w-1/6 min-w-[72px] max-w-[200px]"
                draggable={false}
            />
            <img
                src={getImage("logos/norra.png")}
                className="select-none w-1/4 lg:w-1/6 min-w-[72px] max-w-[200px]"
                draggable={false}
            />
            <img
                src={getImage("logos/skogssallskapet.png")}
                className="select-none w-1/4 lg:w-1/6 min-w-[72px] max-w-[200px]"
                draggable={false}
            />
            <img
                src={getImage("logos/billerud.png")}
                className="select-none w-1/4 lg:w-1/6 min-w-[72px] max-w-[200px]"
                draggable={false}
            />
            <img
                src={getImage("logos/gm.png")}
                className="select-none w-1/4 lg:w-1/6 min-w-[72px] max-w-[200px]"
                draggable={false}
            />
        </div>
    );
}
